<template>
	<div class="content_main">
		<div style="margin-top: 10px">
			<a-button type="primary" @click="application"> 业务费分包费申请 </a-button>
			<a-button type="primary" @click="exp"> 数据导出 </a-button>
		</div>
		<div class="content_main_top">
			<a-input allowClear class="a_input_self margin_self" v-model="queryParam.applyCode" placeholder="审批编号" @keyup.enter.native="query"/>
			<a-input allowClear class="a_input_self margin_self" v-model="queryParam.applyUserName" placeholder="申请人" @keyup.enter.native="query"/>
			<a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 240px" allowClear :value="dates" @change="onChange" @keyup.enter.native="query"
			 :placeholder="['申请开始时间', '申请结束时间']" />
			<a-select placeholder="审批结果" allowClear class="a_input_self margin_self" v-model="queryParam.result" default-value="0" @keyup.enter.native="query">
				<a-select-option :value="''">全部</a-select-option>
				<a-select-option v-for="(val, key) in resultMap" :key="key" :value="key">{{ val }}</a-select-option>
			</a-select>
			<a-select placeholder="审批状态" allowClear class="a_input_self margin_self" v-model="queryParam.status" default-value="0" @keyup.enter.native="query">
				<a-select-option :value="''">全部</a-select-option>
				<a-select-option v-for="(val, key) in status_apply" :key="key" :value="key">{{ val.txt }}</a-select-option>
			</a-select>
			<!-- projectCode -->
			<a-input allowClear class="a_input_self margin_self" v-model="queryParam.projectCode" placeholder="项目编号" @keyup.enter.native="query"/>
			<a-button type="primary" @click="query"> 查询 </a-button>
			<a-button type="primary" ghost @click="result"> 重置 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :columns="columns" :data-source="data" bordered :pagination="pagination" @change="handleTableChange"
			 :scroll="{ y: scroll_y }">
				<span slot="index" slot-scope="text, record, index">
					{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
				</span>
				<span slot="status" slot-scope="text" class="tag_class" :style="{ background: status_apply[text].color }">
					{{ status_apply[text].txt }}
				</span>
				<span slot="result" slot-scope="text" class="tag_class" :style="{ background: result_apply[text].color }">
					{{ result_apply[text].txt }}
				</span>
				<span slot="action" slot-scope="text, record">
					<a @click="handelAudit(record)">详情</a>
					<a-divider type="vertical" />
					<a @click="handFlow(record)">历史</a>
					<a-divider type="vertical" />
					<a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
					<!-- <a-divider type="vertical" />
          <a :disabled="record.status === 1" @click="delByIds([record.buId])">删除</a> -->
				</span>
			</a-table>
		</div>
		<a-modal v-model="appvisible" title="业务费分包费申请" @ok="appOk" width="60%" :maskClosable="false">
			<a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
				<a-row>
					<a-col :span="12">
						<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
							<span class="spanClass" style="font-size: 16px; font-weight: 700; color: gray">表单信息</span>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-form-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
						<ccChange :data="ccC" :money="moneY" v-decorator="['cc']" @targetKeys="getdata" v-if="isRouterAlive" />
					</a-form-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-item label="隶属公司">
							<a-select allowClear placeholder="隶属公司" @change="handlecompanyplan" v-decorator="['companyId', { rules: [{ required: true, message: '请选择隶属公司!' }] }]">
								<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
                                  {{ item.title }}
                                </a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="隶属部门">
							<a-tree-select allowClear :treeData="deptTree" placeholder="隶属部门" v-decorator="['applyDeptId', { rules: [{ required: true, message: '请选择隶属部门!' }] }]"
							 :disabled="!form.getFieldValue('companyId')" @change="leaderid($event)"
							 treeDefaultExpandAll>
							</a-tree-select>
							<!-- <a-select allowClear v-decorator="['applyDeptId', { rules: [{ required: true, message: '请选择隶属部门!' }] }]"
							 :disabled="!form.getFieldValue('companyId')" placeholder="隶属部门" @change="leaderid($event)">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select> -->
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="申请人">
							<a-select show-search allowClear class="margin_self" v-decorator="['applyUser', { rules: [{ required: true, message: '请选择申请人!' }] }]"
							 :disabled="!form.getFieldValue('applyDeptId')" placeholder="申请人">
								<a-select-option :value="item.loginName" v-for="(item, index) in plainOptions" :key="index">
									{{ item.userName }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-item label="项目编号">
							<a-input type="text" allowClear v-decorator="['projectCode', { rules: [{ required: true, message: '请填写项目编号!' }] }]" placeholder="项目编号" @blur="handleConfirmBlur" />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="项目名称">
							<a-input allowClear v-decorator="['projectName', { rules: [{ required: true, message: '请输入项目名称!' }] }]"
							 placeholder="项目名称" />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="项目总金额">
							<a-input allowClear oninput="value=value.replace(/[^\d.]/g,'')" @input="projectPricechange" v-decorator="['projectPrice', { rules: [{ required: true, message: '请输入项目总金额!' }] }]"
							 placeholder="项目总金额" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-item label="支付对象">
							<a-input allowClear v-decorator="['paymentObject', { rules: [{ required: true, message: '请输入支付对象!' }] }]"
							 placeholder="支付对象" />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="新老业务">
							<a-select allowClear class="margin_self" v-decorator="['ifOld', { rules: [{ required: true, message: '请选择新老业务！' }] }]"
							 placeholder="点击选择">
								<a-select-option :value="0">新业务</a-select-option>
								<a-select-option :value="1">续签业务</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="备注">
							<a-textarea :auto-size="{ minRows: 1, maxRows: 3 }" allowClear v-decorator="['remark']" placeholder="不能打印" />
						</a-form-item>
					</a-col>
				</a-row>
				<a-row>
					
					<a-col :span="8">
						<a-form-item label="业务费">
							<a-input type="number" allowClear oninput="value=value.replace(/[^\d.]/g,'')" v-decorator="['commission', { initialValue:0,rules: [{ required: true, message: '请填写业务费!' }] }]" placeholder="业务费"  />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="分包费">
							<a-input type="number" allowClear oninput="value=value.replace(/[^\d.]/g,'')" v-decorator="['subprojectFee', { initialValue:0,rules: [{ required: true, message: '请填写分包费!' }] }]" placeholder="分包费" />
						</a-form-item>
					</a-col>
					<a-col :span="8">
						<a-form-item label="其他费用">
							<a-input type="number" allowClear oninput="value=value.replace(/[^\d.]/g,'')" v-decorator="['otherFee', { initialValue:0,rules: [{ required: true, message: '请填写其他费用!' }] }]" placeholder="其他费用"  />
						</a-form-item>
					</a-col>
					
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-item label="报价单">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-item>
					</a-col>
					
				</a-row>
			</a-form>
		</a-modal>
		<proc-flow-modal ref="modalflow" />
		<operation-modal ref="operationmodal" :audit="false" />
	</div>
</template>

<script>
import { tree_all } from '@/api/purchase'
	import {
		getDeptListEnable2
	} from '@/api/system'
	import debounce from 'lodash/debounce'
	import {
		// get_dept_tree2,
		remove
	} from '@/api/assetmenag'
	import {
		purchaseFee,
		apply_save,
		list_code,
		projectInfo
	} from '@/api/financial'
	import {
		resultMap,
		delProcessIns,
		delBusiness
	} from '@/api/activiti'
	import {
		get_users2,
		get_dict
	} from '@/utils/unit_axios'
	import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue'
	import OperationModal from '../activiti/modules/OperationModal.vue'
	import uploadFileCode from '@/components/module/uploadFileCode.vue'
	import ccChange from '@/components/module/ccChange'
	const columns = [{
			title: '序号',
			dataIndex: 'index',
			key: 'index',
			scopedSlots: {
				customRender: 'index',
			},
			width: 70,
			ellipsis: true,
		},
		{
			title: '审批编号',
			dataIndex: 'applyCode',
			key: 'applyCode',
			ellipsis: true,
		},
		{
			title: '申请人',
			dataIndex: 'applyUserName',
			key: 'applyUserName',
			ellipsis: true,
		},
		{
			title: '申请时间',
			dataIndex: 'createTime',
			key: 'createTime',
			ellipsis: true,
		},
		{
			title: '标题',
			dataIndex: 'title',
			key: 'title',
			ellipsis: true,
		},
		{
			title: '审批结果',
			dataIndex: 'result',
			key: 'result',
			scopedSlots: {
				customRender: 'result',
			},
			ellipsis: true,
		},
		{
			title: '审批状态',
			dataIndex: 'status',
			key: 'status',
			scopedSlots: {
				customRender: 'status',
			},
			ellipsis: true,
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action',
			},
		},
	]
	export default {
		components: {
			ProcFlowModal,
			OperationModal,
			uploadFileCode,
			ccChange,
		},
		data() {
			return {
				noSubmit:true,
				deptTree: [],
				scroll_y: 150,
				columns,
				resultMap,
				dept_id: '',
				asset_sn: '',
				headers: {},
				fileList: [],
				removeList: [],
				plainOptions: [],
				data: '',
				defaultFileList: [],
				file_name: '',
				isRouterAlive: true,
				upload: {
					asset_sn: '',
					dept_id: '',
				},
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				labelCol: {
					span: 9,
				},
				wrapperCol: {
					span: 15,
				},
				labelCol2: {
					span: 2,
				},
				wrapperCol2: {
					span: 22,
				},
				appvisible: false,
				companylist: [],
				form: this.$form.createForm(this),
				deptlist: [],
				queryParam: {},
				dates: [],
				code: '',
				uploadData: {
					code: '',
					type: 'business-fee',
					// types: ['application/pdf', 'image/png', 'image/jpeg', 'application/vnd.ms-excel',
					// 	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					// ],
				},
				ccC: 'businessMoney',
				moneY:'',
			}
		},
		created() {
			// get_dept_tree2().then((res) => {
			// 	this.companylist = res.data.dept_lis
			// 	this.companylist.unshift({
			// 		dept_id: 0,
			// 		dept_name: '所有公司',
			// 		child_lis: [],
			// 	})
			// })
			this.get_sel()
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 100
				}, 1000)
			})
		},
		methods: {
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			projectPricechange(){
				console.log(this.form.getFieldValue('projectPrice'))
				this.moneY=this.form.getFieldValue('projectPrice')
			},
			getdata(data) {
				this.form.setFieldsValue({
					cc: data,
				})
			},
			handelAudit(record) {
				this.$refs.operationmodal.show({
					businessKey: record.buId,
					 procInstId: record.procInstId,
					procDefKey: 'businessMoney',
					 recordNumber: 1
				})
			},
			//历史
			handFlow(row) {
				var obj = {
					procInstId: row.procInstId,
					procDefKey: row.procDefKey
				}
				this.$refs.modalflow.show(obj)
			},
			// 撤销
			cancel(ids) {
				console.log(ids)
				// const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
				delProcessIns({
					ids: ids.join(','),
					reason: '主动撤销',
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success('撤销成功')
						this.get_sel()
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			delByIds(ids) {
				// const idstr = ids.map(r => { return '\'' + r + '\'' }).join('')
				delBusiness({
					ids: ids.join(','),
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success('删除成功')
						this.get_sel()
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			leaderid(id) {
				get_users2(id, (res) => {
					this.plainOptions = res
				})
			},
			onChange(date, dateString) {
				this.dates = date
				this.queryParam.start_date = date[0]
				this.queryParam.end_date = date[1]
			},
			//上传文件
			handleChange(info) {
				info.fileList.forEach((item, idx) => {
					if (item.type != 'application/pdf') {
						info.fileList.splice(idx, 1)
					}
				})
				if (info.file.status !== 'uploading') {
					// info.fileList.splice(info.fileList.length - 1, 1)
				}
				if (info.file.status === 'done') {
					this.$message.success('上传成功')
					this.fileList.push(info.file.response.data + ',' + info.file.name)
					// info.fileList.push(info.file)
				} else if (info.file.status === 'error') {
					this.$message.error('上传失败')
				}
			},
			// 上传各式限制
			beforeUpload(file) {
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok,
				}
				this.upload.asset_sn = this.detailsrow.asset_sn
				this.upload.dept_id = this.detailsrow.dept_id
				var isType = true
				this.file_name = file.name
				const isLt2M = file.size / 1024 / 1024 < 10
				if (!isLt2M) {
					this.$message.error('上传头文件大小不能超过 10MB!')
				}
				if (file.type != 'application/pdf') {
					isType = false
					this.$message.error('只能上传pdf文件')
				}
				return isLt2M && isType
			},
			//预览文件
			previewFile(file) {
				console.log(file)
				window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
			},
			//删除文件
			removeFile(file) {
				this.removeList.push(file.response.data)
				let data = file.response.data + ',' + file.name
				this.fileList.forEach((item, idx) => {
					if (item == data) {
						this.fileList.splice(idx, 1)
					}
				})
				console.log(this.fileList, this.defaultFileList)
			},
			handlecompanyplan(value) {
				console.log('zou',value,this.form.getFieldValue('companyId'))
				this.deptTree=[]
				this.deptlist = []
				this.form.setFieldsValue({
					deptId: undefined,
				})
				this.$nextTick(() => {
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree,this.form.getFieldValue('companyId'))
						}
					})
					// this.companylist.forEach((item) => {
					// 	if (item.dept_id == this.form.getFieldValue('companyId')) {
					// 		this.deptlist = item.child_lis
					// 	}
					// })
				})
			},
			appOk: debounce(
				function() {
					if(this.noSubmit){
						this.$message.error("未找到指定项目请确认项目编号是否正确")
						console.log(this.noSubmit)
					}else{
						this.form.validateFields((err, values) => {
						if (!err) {
							console.log(values)
							if (this.removeList.length > 0) {
								this.removeList.forEach((item) => {
									remove({
										path: item,
									}).then((res) => {
										console.log(res)
									})
								})
							}
							values['ifOld'] = Number(values['ifOld'])
							values['applyCode'] = this.code
							values['quotation'] = this.fileList.join(';')
							values['title'] = this.$store.getters.userInfo.userName
							console.log(values['cc'])
							values['cc'] = values['cc'].length ? values['cc'].join(',') : ''
							apply_save(values)
								.then((res) => {
									if (res.code === 200) {
										this.$message.success('保存成功')
										this.$emit('ok')
										this.appvisible = false
										this.fileList = []
										this.defaultFileList = []
										this.get_sel()
									} else {
										this.$message.error(res.msg)
									}
								})
								.catch(() => {
									this.$message.error('系统错误，请稍后再试')
								})
						}
					})
					}
					
				},
				1000, {
					leading: true,
					trailing: false,
				}
			),
			getcompanyList() {
                tree_all().then(res => {
                if(res.code == 200) {
                this.companylist = res.data[0]
                }
              })
            },
			application() {
				this.getcompanyList()
				this.appvisible = true
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				this.form.resetFields()
				list_code().then((res) => {
					this.code = res.data
					this.uploadData.code = res.data
				})
			},
			get_sel() {
				purchaseFee({
					pageSize: this.pagination.pageSize,
					pageNum: this.pagination.current,
					status: this.queryParam.status,
					result: this.queryParam.result,
					applyUserName: this.queryParam.applyUserName,
					applyCode: this.queryParam.applyCode,
					createTime1: this.queryParam.start_date,
					createTime2: this.queryParam.end_date,
					projectCode: this.queryParam.projectCode
				}).then((res) => {
					const pagination = { ...this.pagination
					}
					pagination.total = res.total
					this.pagination = pagination
					this.data = res.rows
				})
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.get_sel()
			},
			query() {
				this.pagination.current = 1
				this.get_sel()
			},
			result() {
				this.queryParam = {}
			},
			handleConfirmBlur(e){
				let form = this.form
				projectInfo({identifier:form.getFieldValue('projectCode')}).then(res=>{
					// console.log(res,'jiek ')
					if(res.code == 200){
						this.$message.success('项目编号正确')
						form.setFieldsValue({
							projectName:res.data.projectName,
							// companyId:res.data.companyOrder,
							commission:res.data.commission,
							projectPrice:res.data.totalMoney,
							subprojectFee:res.data.subprojectFee,
							ifOld:res.data.old,
							otherFee:res.data.otherExpenses
						})
						console.log(this.companylist,'companylist')
						this.companylist.map(item=>{
							if(res.data.companyOrder == item.title){
								form.setFieldsValue({
									companyId:item.deptId
								})
							}
						})
						console.log(form.getFieldValue('companyId'),'companyId')
						this.handlecompanyplan(form.getFieldValue('companyId'))
						this.noSubmit = false
					}else{
						this.noSubmit = true
						this.$message.error("未找到指定项目请确认项目编号是否正确")
					}
				})
			}
		},
	}
</script>

<style>
	.ant-upload-list-item-name {
		color: #00A2FD;
	}
</style>
